import AuthenticatedController from './AuthenticatedController';
import { LEAD_ASSIGNMENT_GROUPS, LEAD_ASSIGNMENTS } from '@mm/api-routes';
import { LeadAssignmentGroup } from '../interfaces/leadAssignmentGroups';
import { LeadAssignment } from '../interfaces/leadAssignments';

export default class LeadAssignmentsController extends AuthenticatedController {
  static async getAll(botId: number) {
    return super.get(LEAD_ASSIGNMENTS(botId));
  }

  static async create(botId: number, params: Partial<LeadAssignment>) {
    return super.post(LEAD_ASSIGNMENTS(botId), params);
  }

  static async update(
    botId: number,
    leadAssignmentId: number,
    params: Partial<LeadAssignment>,
  ) {
    return super.put(LEAD_ASSIGNMENTS(botId, leadAssignmentId), params);
  }

  static async deleteLeadAssignment(botId: number, leadAssignmentId: number) {
    return super.delete(LEAD_ASSIGNMENTS(botId, leadAssignmentId));
  }

  static async createAgentGroups(
    botId: number,
    params: Partial<LeadAssignmentGroup>,
  ) {
    return super.post(LEAD_ASSIGNMENT_GROUPS(botId), params);
  }

  static async updateAgentGroups(
    botId: number,
    groupId: number,
    params: Partial<LeadAssignmentGroup>,
  ) {
    return super.put(LEAD_ASSIGNMENT_GROUPS(botId, groupId), params);
  }

  static async deleteAgentGroups(botId: number, groupId: number) {
    return super.delete(LEAD_ASSIGNMENT_GROUPS(botId, groupId));
  }

  static async getAgentGroups(botId: number) {
    return super.get(LEAD_ASSIGNMENT_GROUPS(botId));
  }
}
